import { ref, computed, watch } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.regexp.flags.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue";
const _hoisted_1 = {
  class: "top_info"
};
const _hoisted_2 = {
  class: "left_img"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "right_app"
};
const _hoisted_5 = {
  class: "app_name"
};
const _hoisted_6 = {
  class: "channel_info_container"
};
const _hoisted_7 = {
  key: 0,
  class: "left_channel"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["title"];
const _hoisted_10 = ["title"];
const _hoisted_11 = {
  class: "rigth_config"
};
const _hoisted_12 = {
  class: "tab_container"
};
const _hoisted_13 = {
  class: "channel_info_config_wrapper"
};
const _hoisted_14 = {
  class: "draw-btn-content"
};
import { cloneDeep } from 'lodash';
import { getPubStatusProperty } from '../hooks/pubStatus';
import andrioImg from '@/assets/imgs/proAndrioLogo.png';
import gpImg from '@/assets/imgs/proGPLogo.png';
import iosImg from '@/assets/imgs/proIOSLogo.png';
import { queryChannelConfig, queryAppInfo, syncFetch } from '@/api/payManage/appManage';
import { getConfig, queryAccountInfo } from '@/api/payManage/accountManage';
import { OK, awaitWrap, reportEvent } from '@/common';
import { usePay } from '@/views/payManage/appManage/components/usePay';
import { Empty, message } from 'ant-design-vue';
import { useSavePaySetting } from '../hooks/useSavePaySetting';
export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelList',
  props: {
    modalVisible: {
      type: Boolean
    },
    productItem: null,
    choosedChannel: null,
    choosedMarket: null
  },
  emits: ['update:modalVisible', 'updateList'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      rules,
      helpUrl,
      imgUrl,
      douyinRef,
      ordinaryGameRef,
      componentsObj,
      refObj
    } = usePay();
    const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
    const channelList = ref([]);
    const payChannelList = ref([]);
    const curChannel = ref('');
    const curPkg = ref('');
    const curPayChannel = ref('');
    const detailObj = ref({}); // 当前选中的支付类型详情
    const detailForm = ref({}); // 当前选中的应用详情
    const loading = ref(false);
    const imageVisible = ref(false); // 图片预览
    const curLogoImg = computed(() => {
      if (props.choosedMarket === 2) {
        return iosImg;
      } else if (props.choosedMarket === 3) {
        return gpImg;
      }
      return andrioImg;
    });
    const handleCancel = () => {
      emit('update:modalVisible', false);
    }; // 取消
    const setVisible = value => {
      imageVisible.value = value;
    }; // 设置图片预览
    const toHelpWord = () => {
      window.open(helpUrl[curPayChannel.value], '_blank');
    }; // 帮助文档
    const changeChannel = async item => {
      if (!props.productItem.dbtId) return console.error('dbtId不能为空');
      try {
        loading.value = true;
        const {
          code,
          data
        } = await queryChannelConfig({
          dbtId: props.productItem.dbtId
        });
        if (code === OK) {
          var _data$chnlFlags$flags, _data$chnlFlags;
          detailObj.value = data !== null && data !== void 0 ? data : {};
          channelList.value = (_data$chnlFlags$flags = data === null || data === void 0 || (_data$chnlFlags = data.chnlFlags) === null || _data$chnlFlags === void 0 || (_data$chnlFlags = _data$chnlFlags.flags) === null || _data$chnlFlags === void 0 ? void 0 : _data$chnlFlags.filter(ls => ls.hasInternalPurchase)) !== null && _data$chnlFlags$flags !== void 0 ? _data$chnlFlags$flags : [];
        }
      } catch (e) {
        console.error('支付渠道查询失败', e);
      } finally {
        loading.value = false;
      }
      curPkg.value = item.pkg;
      curChannel.value = item.chnlFlag;
      updatePayChannelList(item.payChnls, 'init');
    };
    const changePayChannel = () => {
      initPayConfigDetail();
    };
    const getChannelConfig = async type => {
      if (!props.productItem.dbtId) return console.error('dbtId不能为空');
      try {
        loading.value = true;
        const {
          code,
          data
        } = await queryChannelConfig({
          dbtId: props.productItem.dbtId
        });
        if (code === OK) {
          var _data$chnlFlags$flags2, _data$chnlFlags2, _channelList$value$fi, _channelList$value$fi2, _channelList$value$fi3, _channelList$value$fi4;
          detailObj.value = data !== null && data !== void 0 ? data : {};
          channelList.value = (_data$chnlFlags$flags2 = data === null || data === void 0 || (_data$chnlFlags2 = data.chnlFlags) === null || _data$chnlFlags2 === void 0 || (_data$chnlFlags2 = _data$chnlFlags2.flags) === null || _data$chnlFlags2 === void 0 ? void 0 : _data$chnlFlags2.filter(item => item.hasInternalPurchase)) !== null && _data$chnlFlags$flags2 !== void 0 ? _data$chnlFlags$flags2 : [];
          curPkg.value = (_channelList$value$fi = (_channelList$value$fi2 = channelList.value.find(item => item.chnlFlag === curChannel.value)) === null || _channelList$value$fi2 === void 0 ? void 0 : _channelList$value$fi2.pkg) !== null && _channelList$value$fi !== void 0 ? _channelList$value$fi : '';
          const curPayChnls = (_channelList$value$fi3 = (_channelList$value$fi4 = channelList.value.find(item => item.chnlFlag === curChannel.value)) === null || _channelList$value$fi4 === void 0 ? void 0 : _channelList$value$fi4.payChnls) !== null && _channelList$value$fi3 !== void 0 ? _channelList$value$fi3 : [];
          updatePayChannelList(curPayChnls, type);
        }
      } catch (e) {
        console.error(e);
      } finally {
        loading.value = false;
      }
    };
    const {
      submitForm,
      savePaySetting
    } = useSavePaySetting({
      curPayChannel,
      detailForm,
      detailObj,
      props,
      getChannelConfig,
      refsMap: refObj
    });
    const updatePayChannelList = (payChnls, type) => {
      var _payChannelList$value;
      // 深拷贝数组，避免修改原数组
      const newPayChnls = cloneDeep(payChnls);
      // 添加"更新记录" tab（如果还没有）
      const hasRecordUpdate = newPayChnls.some(item => item.payChnlConfigComponent === 'recordUpdate');
      if (!hasRecordUpdate && payChnls.length > 0) {
        // 没有更新记录且有tab值再插入
        newPayChnls.push({
          payChnlConfigComponent: 'recordUpdate',
          payChlCode: 'recordUpdate',
          payChlName: '更新记录'
        });
      }
      payChannelList.value = newPayChnls;
      if (type === 'init') {
        var _newPayChnls$0$payChn, _newPayChnls$;
        curPayChannel.value = (_newPayChnls$0$payChn = (_newPayChnls$ = newPayChnls[0]) === null || _newPayChnls$ === void 0 ? void 0 : _newPayChnls$.payChnlConfigComponent) !== null && _newPayChnls$0$payChn !== void 0 ? _newPayChnls$0$payChn : ''; // 默认选中第一个支付渠道
      }
      ((_payChannelList$value = payChannelList.value) === null || _payChannelList$value === void 0 ? void 0 : _payChannelList$value.length) && initPayConfigDetail();
    };
    // 初始化相关配置内容信息
    const initPayConfigDetail = () => {
      // 提供更新配置
      if (curPayChannel.value === 'recordUpdate') {
        detailForm.value = {
          dbtId: props.productItem.dbtId,
          id: detailObj.value.mchId,
          chnlFlag: curChannel.value,
          curPayChannel: curPayChannel.value,
          bizId: curPkg.value
        };
        return;
      }
      if (['google', 'apple'].includes(curPayChannel.value)) {
        getAppInfoDetail();
        getAccountInfo();
      } else {
        getAccountDetail();
      }
    };
    // 获取分成比例
    const getAccountInfo = async () => {
      var _detailObj$value;
      const [err, data] = await awaitWrap(queryAccountInfo({
        accountId: (_detailObj$value = detailObj.value) === null || _detailObj$value === void 0 ? void 0 : _detailObj$value.accountId
      }));
      if (data && data.code === OK) {
        detailForm.value.divide = data.data.coefficient || '0.85';
      } else {
        detailForm.value.divide = '';
      }
      if (err) {}
    };
    // 获取账号相关信息
    const getAppInfoDetail = async () => {
      var _detailObj$value4;
      const {
        data,
        code
      } = await queryAppInfo({
        dbtId: props.productItem.dbtId
      }).catch(e => {});
      if (code === OK) {
        var _detailObj$value2;
        Object.assign(detailForm.value, data);
        if ((_detailObj$value2 = detailObj.value) !== null && _detailObj$value2 !== void 0 && (_detailObj$value2 = _detailObj$value2.config) !== null && _detailObj$value2 !== void 0 && _detailObj$value2[curPayChannel.value]) {
          var _detailObj$value3;
          Object.assign(detailForm.value, (_detailObj$value3 = detailObj.value) === null || _detailObj$value3 === void 0 || (_detailObj$value3 = _detailObj$value3.config) === null || _detailObj$value3 === void 0 || (_detailObj$value3 = _detailObj$value3[curPayChannel.value]) === null || _detailObj$value3 === void 0 ? void 0 : _detailObj$value3[0]);
        }
      } else if ((_detailObj$value4 = detailObj.value) !== null && _detailObj$value4 !== void 0 && (_detailObj$value4 = _detailObj$value4.config) !== null && _detailObj$value4 !== void 0 && _detailObj$value4[curPayChannel.value]) {
        var _detailObj$value5;
        // 接口调用失败取query接口的config 没有则为空
        Object.assign(detailForm.value, (_detailObj$value5 = detailObj.value) === null || _detailObj$value5 === void 0 || (_detailObj$value5 = _detailObj$value5.config) === null || _detailObj$value5 === void 0 || (_detailObj$value5 = _detailObj$value5[curPayChannel.value]) === null || _detailObj$value5 === void 0 ? void 0 : _detailObj$value5[0]);
      } else {
        Object.assign(detailForm.value, {
          pkg: ''
        });
      }
    }; // 获取应用详情
    const syncDetail = async () => {
      try {
        const {
          code
        } = await syncFetch({
          dbtIdList: [props.productItem.dbtId]
        });
        if (code === OK) {
          message.success('同步成功');
          getChannelConfig('update');
          emit('updateList');
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '产品管理',
              element_name: '同步支付渠道'
            }
          });
        }
      } catch (e) {
        console.error(e);
      }
    };
    // 获取应用信息详情
    const getAccountDetail = async () => {
      var _data$wxPayBaseConfig, _data$wxPayBaseConfig2, _detailObj$value7, _detailForm$value$cha, _detailObj$value8, _data$wxPayBaseConfig3, _data$wxPayBaseConfig4, _data$wxPayBaseConfig5, _data$wxPayBaseConfig6, _data$wxPayBaseConfig7, _detailObj$value11, _detailForm$value$cha2, _detailObj$value12, _data$aliPayBaseConfi, _detailObj$value13, _detailForm$value$cha3, _detailObj$value14, _data$aliPayBaseConfi2, _detailObj$value17, _detailForm$value$cha4, _detailObj$value18, _data$wxPayBaseConfig8, _data$wxPayBaseConfig9, _data$wxPayBaseConfig10, _data$wxPayBaseConfig11, _detailObj$value21, _detailForm$value$cha5, _detailObj$value22, _data$wxPayBaseConfig12, _data$wxPayBaseConfig13, _data$wxPayBaseConfig14, _detailObj$value23, _detailForm$value$div2, _detailObj$value24, _data$wxPayBaseConfig15, _data$wxPayBaseConfig16, _data$wxPayBaseConfig17, _detailObj$value25, _detailForm$value$div3, _detailObj$value26, _data$douyinPayBaseCo, _detailObj$value27, _detailObj$value28, _detailForm$value$rat, _detailObj$value29, _data$douyinPayBaseCo2, _detailObj$value30, _detailObj$value31, _detailForm$value$rat2, _detailObj$value32, _detailObj$value33, _detailForm$value$rat3, _detailObj$value34, _detailObj$value35, _detailForm$value$rat4, _detailObj$value36, _detailObj$value37, _detailForm$value$rat5, _detailObj$value38, _detailObj$value39, _detailForm$value$rat6, _detailObj$value40, _detailObj$value41, _detailForm$value$rat7, _detailObj$value42, _data$amazon, _detailObj$value43, _detailForm$value$rat8, _detailObj$value44, _data$vivo, _detailObj$value45, _detailForm$value$rat9, _detailObj$value46, _detailObj$value47, _detailForm$value$rat10, _detailObj$value48, _detailObj$value49, _detailForm$value$rat11, _detailObj$value50, _data$vivo2, _detailObj$value51, _detailForm$value$rat12, _detailObj$value52, _detailObj$value53, _detailForm$value$rat13, _detailObj$value54, _detailObj$value55, _detailForm$value$rat14, _detailObj$value56;
      try {
        var _payChannelList$value2, _detailObj$value6;
        detailForm.value = {}; // 重置详情值
        const payChnl = (_payChannelList$value2 = payChannelList.value.find(item => item.payChnlConfigComponent === curPayChannel.value)) === null || _payChannelList$value2 === void 0 ? void 0 : _payChannelList$value2.payChlCode;
        const {
          code,
          data
        } = await getConfig({
          id: (_detailObj$value6 = detailObj.value) === null || _detailObj$value6 === void 0 ? void 0 : _detailObj$value6.mchId,
          payChnl
        });
        if (code === OK) {
          switch (curPayChannel.value) {
            case 'wxPayBaseConfig':
              detailForm.value.mchName = data.mchName;
              detailForm.value.merchants = (_data$wxPayBaseConfig = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig === void 0 ? void 0 : _data$wxPayBaseConfig.merchants;
              detailForm.value.apiKey = (_data$wxPayBaseConfig2 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig2 === void 0 ? void 0 : _data$wxPayBaseConfig2.apiKeyV2;
              detailForm.value.channelRateList = ((_detailObj$value7 = detailObj.value) === null || _detailObj$value7 === void 0 || (_detailObj$value7 = _detailObj$value7.radioConfig) === null || _detailObj$value7 === void 0 || (_detailObj$value7 = _detailObj$value7.wxPayChannel) === null || _detailObj$value7 === void 0 || (_detailObj$value7 = _detailObj$value7.channelRate) === null || _detailObj$value7 === void 0 ? void 0 : _detailObj$value7.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '0.9%',
                value: '0.009',
                isDefault: true
              }];
              detailForm.value.channelRate = (_detailForm$value$cha = detailForm.value.channelRateList.find(item => item.isDefault)) === null || _detailForm$value$cha === void 0 ? void 0 : _detailForm$value$cha.value;
              if ((_detailObj$value8 = detailObj.value) !== null && _detailObj$value8 !== void 0 && (_detailObj$value8 = _detailObj$value8.config) !== null && _detailObj$value8 !== void 0 && _detailObj$value8.wxPayChannel) {
                var _detailObj$value9, _detailObj$value$conf, _wxMatchItem$channelD, _detailObj$value$conf2, _detailObj$value10;
                Object.assign(detailForm.value, (_detailObj$value9 = detailObj.value) === null || _detailObj$value9 === void 0 || (_detailObj$value9 = _detailObj$value9.config) === null || _detailObj$value9 === void 0 ? void 0 : _detailObj$value9.wxPayChannel);
                const wxMatchItem = (_detailObj$value$conf = detailObj.value.config.wxPayChannel.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf !== void 0 ? _detailObj$value$conf : detailObj.value.config.wxPayChannel[0];
                detailForm.value.channelRate = wxMatchItem === null || wxMatchItem === void 0 || (_wxMatchItem$channelD = wxMatchItem.channelData) === null || _wxMatchItem$channelD === void 0 ? void 0 : _wxMatchItem$channelD.channelRate;
                detailForm.value.pkgList = (_detailObj$value$conf2 = (_detailObj$value10 = detailObj.value) === null || _detailObj$value10 === void 0 || (_detailObj$value10 = _detailObj$value10.config) === null || _detailObj$value10 === void 0 || (_detailObj$value10 = _detailObj$value10.wxPayChannel) === null || _detailObj$value10 === void 0 || (_detailObj$value10 = _detailObj$value10.filter(item => item.pkg === curPkg.value)) === null || _detailObj$value10 === void 0 ? void 0 : _detailObj$value10.map(item => {
                  var _item$channelData, _item$channelData2;
                  return {
                    ...item,
                    pkg: item.pkg,
                    appId: (_item$channelData = item.channelData) === null || _item$channelData === void 0 ? void 0 : _item$channelData.appId,
                    appSecret: (_item$channelData2 = item.channelData) === null || _item$channelData2 === void 0 ? void 0 : _item$channelData2.appSecret
                  };
                })) !== null && _detailObj$value$conf2 !== void 0 ? _detailObj$value$conf2 : [];
              }
              break;
            case 'wxnativepay':
              detailForm.value.mchName = data.mchName;
              detailForm.value.merchants = (_data$wxPayBaseConfig3 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig3 === void 0 ? void 0 : _data$wxPayBaseConfig3.merchants;
              detailForm.value.apiKey = (_data$wxPayBaseConfig4 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig4 === void 0 ? void 0 : _data$wxPayBaseConfig4.apiKeyV2;
              detailForm.value.wxPriKey = (_data$wxPayBaseConfig5 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig5 === void 0 ? void 0 : _data$wxPayBaseConfig5.wxPriKey;
              detailForm.value.apiKeyV3 = (_data$wxPayBaseConfig6 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig6 === void 0 ? void 0 : _data$wxPayBaseConfig6.apiKeyV3;
              detailForm.value.certSerialNo = (_data$wxPayBaseConfig7 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig7 === void 0 ? void 0 : _data$wxPayBaseConfig7.certSerialNo;
              detailForm.value.channelRateList = ((_detailObj$value11 = detailObj.value) === null || _detailObj$value11 === void 0 || (_detailObj$value11 = _detailObj$value11.radioConfig) === null || _detailObj$value11 === void 0 || (_detailObj$value11 = _detailObj$value11.wxnativepay) === null || _detailObj$value11 === void 0 || (_detailObj$value11 = _detailObj$value11.channelRate) === null || _detailObj$value11 === void 0 ? void 0 : _detailObj$value11.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '0.9%',
                value: '0.009',
                isDefault: true
              }];
              detailForm.value.channelRate = (_detailForm$value$cha2 = detailForm.value.channelRateList.find(item => item.isDefault)) === null || _detailForm$value$cha2 === void 0 ? void 0 : _detailForm$value$cha2.value;
              if ((_detailObj$value12 = detailObj.value) !== null && _detailObj$value12 !== void 0 && (_detailObj$value12 = _detailObj$value12.config) !== null && _detailObj$value12 !== void 0 && _detailObj$value12.wxnativepay) {
                var _detailObj$value$conf3;
                const matchItem = (_detailObj$value$conf3 = detailObj.value.config.wxnativepay.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf3 !== void 0 ? _detailObj$value$conf3 : detailObj.value.config.wxnativepay[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'aliPayBaseConfig':
              detailForm.value.mchName = data.mchName;
              detailForm.value.publicKey = (_data$aliPayBaseConfi = data.aliPayBaseConfig) === null || _data$aliPayBaseConfi === void 0 ? void 0 : _data$aliPayBaseConfi.publicKey;
              detailForm.value.appGateway = data.aliPayGateWay;
              detailForm.value.channelRateList = ((_detailObj$value13 = detailObj.value) === null || _detailObj$value13 === void 0 || (_detailObj$value13 = _detailObj$value13.radioConfig) === null || _detailObj$value13 === void 0 || (_detailObj$value13 = _detailObj$value13.aliPayChannel) === null || _detailObj$value13 === void 0 || (_detailObj$value13 = _detailObj$value13.channelRate) === null || _detailObj$value13 === void 0 ? void 0 : _detailObj$value13.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '1%',
                value: '0.01',
                isDefault: true
              }];
              detailForm.value.channelRate = (_detailForm$value$cha3 = detailForm.value.channelRateList.find(item => item.isDefault)) === null || _detailForm$value$cha3 === void 0 ? void 0 : _detailForm$value$cha3.value;
              if ((_detailObj$value14 = detailObj.value) !== null && _detailObj$value14 !== void 0 && (_detailObj$value14 = _detailObj$value14.config) !== null && _detailObj$value14 !== void 0 && _detailObj$value14.aliPayChannel) {
                var _detailObj$value15, _detailObj$value$conf4, _aliMatchItem$channel, _aliMatchItem$channel2, _aliMatchItem$channel3, _aliMatchItem$channel4, _detailObj$value$conf5, _detailObj$value16;
                Object.assign(detailForm.value, (_detailObj$value15 = detailObj.value) === null || _detailObj$value15 === void 0 || (_detailObj$value15 = _detailObj$value15.config) === null || _detailObj$value15 === void 0 ? void 0 : _detailObj$value15.aliPayChannel);
                const aliMatchItem = (_detailObj$value$conf4 = detailObj.value.config.aliPayChannel.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf4 !== void 0 ? _detailObj$value$conf4 : detailObj.value.config.aliPayChannel[0];
                detailForm.value.appPublicKey = aliMatchItem === null || aliMatchItem === void 0 || (_aliMatchItem$channel = aliMatchItem.channelData) === null || _aliMatchItem$channel === void 0 ? void 0 : _aliMatchItem$channel.appPublicKey;
                detailForm.value.appPrivateKey = aliMatchItem === null || aliMatchItem === void 0 || (_aliMatchItem$channel2 = aliMatchItem.channelData) === null || _aliMatchItem$channel2 === void 0 ? void 0 : _aliMatchItem$channel2.appPrivateKey;
                detailForm.value.appId = aliMatchItem === null || aliMatchItem === void 0 || (_aliMatchItem$channel3 = aliMatchItem.channelData) === null || _aliMatchItem$channel3 === void 0 ? void 0 : _aliMatchItem$channel3.appId;
                detailForm.value.channelRate = aliMatchItem === null || aliMatchItem === void 0 || (_aliMatchItem$channel4 = aliMatchItem.channelData) === null || _aliMatchItem$channel4 === void 0 ? void 0 : _aliMatchItem$channel4.channelRate;
                detailForm.value.pkgListTemp = JSON.stringify((_detailObj$value$conf5 = (_detailObj$value16 = detailObj.value) === null || _detailObj$value16 === void 0 || (_detailObj$value16 = _detailObj$value16.config) === null || _detailObj$value16 === void 0 || (_detailObj$value16 = _detailObj$value16.aliPayChannel) === null || _detailObj$value16 === void 0 || (_detailObj$value16 = _detailObj$value16.filter(item => item.pkg === curPkg.value)) === null || _detailObj$value16 === void 0 ? void 0 : _detailObj$value16.map(item => {
                  return {
                    ...item,
                    pkg: item.pkg
                  };
                })) !== null && _detailObj$value$conf5 !== void 0 ? _detailObj$value$conf5 : []);
              }
              break;
            case 'aliWebPayBaseConfig':
              detailForm.value.mchName = data.mchName;
              detailForm.value.publicKey = (_data$aliPayBaseConfi2 = data.aliPayBaseConfig) === null || _data$aliPayBaseConfi2 === void 0 ? void 0 : _data$aliPayBaseConfi2.publicKey;
              detailForm.value.appGateway = data.aliPayGateWay;
              detailForm.value.channelRateList = ((_detailObj$value17 = detailObj.value) === null || _detailObj$value17 === void 0 || (_detailObj$value17 = _detailObj$value17.radioConfig) === null || _detailObj$value17 === void 0 || (_detailObj$value17 = _detailObj$value17.aliWebPayChannel) === null || _detailObj$value17 === void 0 || (_detailObj$value17 = _detailObj$value17.channelRate) === null || _detailObj$value17 === void 0 ? void 0 : _detailObj$value17.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '1%',
                value: '0.01',
                isDefault: true
              }];
              detailForm.value.channelRate = (_detailForm$value$cha4 = detailForm.value.channelRateList.find(item => item.isDefault)) === null || _detailForm$value$cha4 === void 0 ? void 0 : _detailForm$value$cha4.value;
              if ((_detailObj$value18 = detailObj.value) !== null && _detailObj$value18 !== void 0 && (_detailObj$value18 = _detailObj$value18.config) !== null && _detailObj$value18 !== void 0 && _detailObj$value18.aliWebPayChannel) {
                var _detailObj$value$conf6, _matchItem$channelDat, _matchItem$channelDat2;
                const matchItem = (_detailObj$value$conf6 = detailObj.value.config.aliWebPayChannel.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf6 !== void 0 ? _detailObj$value$conf6 : detailObj.value.config.aliWebPayChannel[0];
                Object.assign(detailForm.value, matchItem);
                detailForm.value.appId = matchItem === null || matchItem === void 0 || (_matchItem$channelDat = matchItem.channelData) === null || _matchItem$channelDat === void 0 ? void 0 : _matchItem$channelDat.appId;
                detailForm.value.appPrivateKey = matchItem === null || matchItem === void 0 || (_matchItem$channelDat2 = matchItem.channelData) === null || _matchItem$channelDat2 === void 0 ? void 0 : _matchItem$channelDat2.appPrivateKey;
              }
              break;
            case 'aliminigame':
            case 'aliminigame_ios':
              {
                var _detailObj$value19, _data$aliPayBaseConfi3, _detailForm$value$div, _detailObj$value20;
                const channelKey = curPayChannel.value;
                const divideConfig = (_detailObj$value19 = detailObj.value) === null || _detailObj$value19 === void 0 || (_detailObj$value19 = _detailObj$value19.radioConfig) === null || _detailObj$value19 === void 0 || (_detailObj$value19 = _detailObj$value19[channelKey]) === null || _detailObj$value19 === void 0 ? void 0 : _detailObj$value19.divide;
                const defaultDivideList = channelKey === 'aliminigame_ios' ? [{
                  label: '40%',
                  value: '0.4',
                  isDefault: true
                }, {
                  label: '80%',
                  value: '0.8',
                  isDefault: false
                }] : [{
                  label: '40%',
                  value: '0.4',
                  isDefault: true
                }];
                detailForm.value.mchName = data.mchName;
                detailForm.value.publicKey = (_data$aliPayBaseConfi3 = data.aliPayBaseConfig) === null || _data$aliPayBaseConfi3 === void 0 ? void 0 : _data$aliPayBaseConfi3.publicKey;
                detailForm.value.appGateway = data.aliPayGateWay;
                detailForm.value.divideList = divideConfig !== null && divideConfig !== void 0 && divideConfig.length ? divideConfig.map(item => {
                  return {
                    label: item.dictName,
                    value: item.dictValue.toString(),
                    isDefault: item.defaultOption == 1
                  };
                }) : defaultDivideList;
                detailForm.value.divide = (_detailForm$value$div = detailForm.value.divideList.find(item => item.isDefault)) === null || _detailForm$value$div === void 0 ? void 0 : _detailForm$value$div.value;
                const channelConfigList = (_detailObj$value20 = detailObj.value) === null || _detailObj$value20 === void 0 || (_detailObj$value20 = _detailObj$value20.config) === null || _detailObj$value20 === void 0 ? void 0 : _detailObj$value20[channelKey];
                if (channelConfigList !== null && channelConfigList !== void 0 && channelConfigList.length) {
                  var _channelConfigList$fi, _matchItem$channelDat3, _matchItem$channelDat4, _matchItem$channelDat5, _matchItem$channelDat6, _matchItem$channelDat7;
                  const matchItem = (_channelConfigList$fi = channelConfigList.find(item => item.pkg === curPkg.value)) !== null && _channelConfigList$fi !== void 0 ? _channelConfigList$fi : channelConfigList[0];
                  Object.assign(detailForm.value, matchItem);
                  detailForm.value.appPublicKey = matchItem === null || matchItem === void 0 || (_matchItem$channelDat3 = matchItem.channelData) === null || _matchItem$channelDat3 === void 0 ? void 0 : _matchItem$channelDat3.appPublicKey;
                  detailForm.value.appPrivateKey = matchItem === null || matchItem === void 0 || (_matchItem$channelDat4 = matchItem.channelData) === null || _matchItem$channelDat4 === void 0 ? void 0 : _matchItem$channelDat4.appPrivateKey;
                  detailForm.value.appId = matchItem === null || matchItem === void 0 || (_matchItem$channelDat5 = matchItem.channelData) === null || _matchItem$channelDat5 === void 0 ? void 0 : _matchItem$channelDat5.appId;
                  detailForm.value.divide = (_matchItem$channelDat6 = matchItem === null || matchItem === void 0 || (_matchItem$channelDat7 = matchItem.channelData) === null || _matchItem$channelDat7 === void 0 ? void 0 : _matchItem$channelDat7.divide) !== null && _matchItem$channelDat6 !== void 0 ? _matchItem$channelDat6 : detailForm.value.divide;
                }
                break;
              }
            case 'jsApiPayBaseConfig':
              detailForm.value.mchName = data.mchName;
              detailForm.value.merchants = (_data$wxPayBaseConfig8 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig8 === void 0 ? void 0 : _data$wxPayBaseConfig8.merchants;
              detailForm.value.wxPriKey = (_data$wxPayBaseConfig9 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig9 === void 0 ? void 0 : _data$wxPayBaseConfig9.wxPriKey;
              detailForm.value.apiKeyV3 = (_data$wxPayBaseConfig10 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig10 === void 0 ? void 0 : _data$wxPayBaseConfig10.apiKeyV3;
              detailForm.value.certSerialNo = (_data$wxPayBaseConfig11 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig11 === void 0 ? void 0 : _data$wxPayBaseConfig11.certSerialNo;
              detailForm.value.channelRateList = ((_detailObj$value21 = detailObj.value) === null || _detailObj$value21 === void 0 || (_detailObj$value21 = _detailObj$value21.radioConfig) === null || _detailObj$value21 === void 0 || (_detailObj$value21 = _detailObj$value21.jsApiPayChannel) === null || _detailObj$value21 === void 0 || (_detailObj$value21 = _detailObj$value21.channelRate) === null || _detailObj$value21 === void 0 ? void 0 : _detailObj$value21.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '0.9%',
                value: '0.009',
                isDefault: true
              }];
              detailForm.value.channelRate = (_detailForm$value$cha5 = detailForm.value.channelRateList.find(item => item.isDefault)) === null || _detailForm$value$cha5 === void 0 ? void 0 : _detailForm$value$cha5.value;
              if ((_detailObj$value22 = detailObj.value) !== null && _detailObj$value22 !== void 0 && (_detailObj$value22 = _detailObj$value22.config) !== null && _detailObj$value22 !== void 0 && _detailObj$value22.jsApiPayChannel) {
                var _detailObj$value$conf7;
                const matchItem = (_detailObj$value$conf7 = detailObj.value.config.jsApiPayChannel.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf7 !== void 0 ? _detailObj$value$conf7 : detailObj.value.config.jsApiPayChannel[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
                detailForm.value.divide = detailForm.value.divide * 100 + '%';
              }
              break;
            case 'wxMinGamePayBaseConfig':
              detailForm.value.mchName = data.mchName;
              detailForm.value.merchants = (_data$wxPayBaseConfig12 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig12 === void 0 ? void 0 : _data$wxPayBaseConfig12.merchants;
              detailForm.value.wxPriKey = (_data$wxPayBaseConfig13 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig13 === void 0 ? void 0 : _data$wxPayBaseConfig13.wxPriKey;
              detailForm.value.apiKeyV3 = (_data$wxPayBaseConfig14 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig14 === void 0 ? void 0 : _data$wxPayBaseConfig14.apiKeyV3;
              detailForm.value.divideList = ((_detailObj$value23 = detailObj.value) === null || _detailObj$value23 === void 0 || (_detailObj$value23 = _detailObj$value23.radioConfig) === null || _detailObj$value23 === void 0 || (_detailObj$value23 = _detailObj$value23.wxMinGamePayChannel) === null || _detailObj$value23 === void 0 || (_detailObj$value23 = _detailObj$value23.divide) === null || _detailObj$value23 === void 0 ? void 0 : _detailObj$value23.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '60%',
                value: '0.6',
                isDefault: true
              }, {
                label: '70%',
                value: '0.7',
                isDefault: false
              }];
              detailForm.value.divide = (_detailForm$value$div2 = detailForm.value.divideList.find(item => item.isDefault)) === null || _detailForm$value$div2 === void 0 ? void 0 : _detailForm$value$div2.value;
              if ((_detailObj$value24 = detailObj.value) !== null && _detailObj$value24 !== void 0 && (_detailObj$value24 = _detailObj$value24.config) !== null && _detailObj$value24 !== void 0 && _detailObj$value24.wxMinGamePayChannel) {
                var _detailObj$value$conf8;
                const matchItem = (_detailObj$value$conf8 = detailObj.value.config.wxMinGamePayChannel.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf8 !== void 0 ? _detailObj$value$conf8 : detailObj.value.config.wxMinGamePayChannel[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            // wx小游戏区分安卓和ios方便后期管理
            case 'wxMinGameIosPayBaseConfig':
              detailForm.value.mchName = data.mchName;
              detailForm.value.merchants = (_data$wxPayBaseConfig15 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig15 === void 0 ? void 0 : _data$wxPayBaseConfig15.merchants;
              detailForm.value.wxPriKey = (_data$wxPayBaseConfig16 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig16 === void 0 ? void 0 : _data$wxPayBaseConfig16.wxPriKey;
              detailForm.value.apiKeyV3 = (_data$wxPayBaseConfig17 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig17 === void 0 ? void 0 : _data$wxPayBaseConfig17.apiKeyV3;
              detailForm.value.divideList = ((_detailObj$value25 = detailObj.value) === null || _detailObj$value25 === void 0 || (_detailObj$value25 = _detailObj$value25.radioConfig) === null || _detailObj$value25 === void 0 || (_detailObj$value25 = _detailObj$value25.wxMinGameIosPayChannel) === null || _detailObj$value25 === void 0 || (_detailObj$value25 = _detailObj$value25.divide) === null || _detailObj$value25 === void 0 ? void 0 : _detailObj$value25.map(item => {
                return {
                  label: item.dictName,
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '60%',
                value: '0.6',
                isDefault: true
              }, {
                label: '70%',
                value: '0.7',
                isDefault: false
              }];
              detailForm.value.divide = (_detailForm$value$div3 = detailForm.value.divideList.find(item => item.isDefault)) === null || _detailForm$value$div3 === void 0 ? void 0 : _detailForm$value$div3.value;
              if ((_detailObj$value26 = detailObj.value) !== null && _detailObj$value26 !== void 0 && (_detailObj$value26 = _detailObj$value26.config) !== null && _detailObj$value26 !== void 0 && _detailObj$value26.wxMinGameIosPayChannel) {
                var _detailObj$value$conf9;
                const matchItem = (_detailObj$value$conf9 = detailObj.value.config.wxMinGameIosPayChannel.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf9 !== void 0 ? _detailObj$value$conf9 : detailObj.value.config.wxMinGameIosPayChannel[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'douyinUnityPayBaseConfig':
              detailForm.value.mchName = data.mchName;
              detailForm.value.valueAddedTaxRateId = (_data$douyinPayBaseCo = data.douyinPayBaseConfig) === null || _data$douyinPayBaseCo === void 0 ? void 0 : _data$douyinPayBaseCo.valueAddedTaxRateId;
              detailForm.value.mainChannelType = 'douyinUnityPayBaseConfig';
              detailForm.value.mchId = (_detailObj$value27 = detailObj.value) === null || _detailObj$value27 === void 0 ? void 0 : _detailObj$value27.mchId;
              detailForm.value.rateList = ((_detailObj$value28 = detailObj.value) === null || _detailObj$value28 === void 0 || (_detailObj$value28 = _detailObj$value28.radioConfig) === null || _detailObj$value28 === void 0 || (_detailObj$value28 = _detailObj$value28.douyinUnityPayChannel) === null || _detailObj$value28 === void 0 || (_detailObj$value28 = _detailObj$value28.rate) === null || _detailObj$value28 === void 0 ? void 0 : _detailObj$value28.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '60%',
                value: '0.6',
                isDefault: true
              }, {
                label: '90%',
                value: '0.9',
                isDefault: false
              }];
              detailForm.value.rate = (_detailForm$value$rat = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat === void 0 ? void 0 : _detailForm$value$rat.value;
              // await douyinRef.value.handleCalDivide()
              await douyinRef.value.getDouyinRateList();
              if ((_detailObj$value29 = detailObj.value) !== null && _detailObj$value29 !== void 0 && (_detailObj$value29 = _detailObj$value29.config) !== null && _detailObj$value29 !== void 0 && _detailObj$value29.douyinUnityPayChannel) {
                var _detailObj$value$conf10;
                const matchItem = (_detailObj$value$conf10 = detailObj.value.config.douyinUnityPayChannel.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf10 !== void 0 ? _detailObj$value$conf10 : detailObj.value.config.douyinUnityPayChannel[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
                detailForm.value.channelRate += '%';
              }
              break;
            case 'douyinOrdinaryMiniGame':
              detailForm.value.mchName = data.mchName;
              detailForm.value.valueAddedTaxRateId = (_data$douyinPayBaseCo2 = data.douyinPayBaseConfig) === null || _data$douyinPayBaseCo2 === void 0 ? void 0 : _data$douyinPayBaseCo2.valueAddedTaxRateId;
              detailForm.value.mainChannelType = 'douyinOrdinaryMiniGame';
              detailForm.value.mchId = (_detailObj$value30 = detailObj.value) === null || _detailObj$value30 === void 0 ? void 0 : _detailObj$value30.mchId;
              detailForm.value.rateList = ((_detailObj$value31 = detailObj.value) === null || _detailObj$value31 === void 0 || (_detailObj$value31 = _detailObj$value31.radioConfig) === null || _detailObj$value31 === void 0 || (_detailObj$value31 = _detailObj$value31.douyinOrdinaryMiniGame) === null || _detailObj$value31 === void 0 || (_detailObj$value31 = _detailObj$value31.rate) === null || _detailObj$value31 === void 0 ? void 0 : _detailObj$value31.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '60%',
                value: '0.6',
                isDefault: true
              }, {
                label: '90%',
                value: '0.9',
                isDefault: false
              }];
              detailForm.value.rate = (_detailForm$value$rat2 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat2 === void 0 ? void 0 : _detailForm$value$rat2.value;
              await ordinaryGameRef.value.getDouyinRateList();
              if ((_detailObj$value32 = detailObj.value) !== null && _detailObj$value32 !== void 0 && (_detailObj$value32 = _detailObj$value32.config) !== null && _detailObj$value32 !== void 0 && _detailObj$value32.douyinOrdinaryMiniGame) {
                var _detailObj$value$conf11;
                const matchItem = (_detailObj$value$conf11 = detailObj.value.config.douyinOrdinaryMiniGame.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf11 !== void 0 ? _detailObj$value$conf11 : detailObj.value.config.douyinOrdinaryMiniGame[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'huawei':
              detailForm.value.publishType = detailObj.value.productType;
              detailForm.value.rateList = ((_detailObj$value33 = detailObj.value) === null || _detailObj$value33 === void 0 || (_detailObj$value33 = _detailObj$value33.radioConfig) === null || _detailObj$value33 === void 0 || (_detailObj$value33 = _detailObj$value33.huawei) === null || _detailObj$value33 === void 0 || (_detailObj$value33 = _detailObj$value33.divide) === null || _detailObj$value33 === void 0 ? void 0 : _detailObj$value33.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '50%',
                value: '0.5',
                isDefault: true
              }, {
                label: '70%',
                value: '0.7',
                isDefault: false
              }];
              detailForm.value.divide = (_detailForm$value$rat3 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat3 === void 0 ? void 0 : _detailForm$value$rat3.value;
              if ((_detailObj$value34 = detailObj.value) !== null && _detailObj$value34 !== void 0 && (_detailObj$value34 = _detailObj$value34.config) !== null && _detailObj$value34 !== void 0 && _detailObj$value34.huawei) {
                var _detailObj$value$conf12;
                const matchItem = (_detailObj$value$conf12 = detailObj.value.config.huawei.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf12 !== void 0 ? _detailObj$value$conf12 : detailObj.value.config.huawei[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'harmony':
              detailForm.value.publishType = detailObj.value.productType;
              detailForm.value.rateList = ((_detailObj$value35 = detailObj.value) === null || _detailObj$value35 === void 0 || (_detailObj$value35 = _detailObj$value35.radioConfig) === null || _detailObj$value35 === void 0 || (_detailObj$value35 = _detailObj$value35.harmony) === null || _detailObj$value35 === void 0 || (_detailObj$value35 = _detailObj$value35.divide) === null || _detailObj$value35 === void 0 ? void 0 : _detailObj$value35.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '50%',
                value: '0.5',
                isDefault: true
              }, {
                label: '70%',
                value: '0.7',
                isDefault: false
              }];
              detailForm.value.divide = (_detailForm$value$rat4 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat4 === void 0 ? void 0 : _detailForm$value$rat4.value;
              if ((_detailObj$value36 = detailObj.value) !== null && _detailObj$value36 !== void 0 && (_detailObj$value36 = _detailObj$value36.config) !== null && _detailObj$value36 !== void 0 && _detailObj$value36.harmony) {
                var _detailObj$value$conf13;
                const matchItem = (_detailObj$value$conf13 = detailObj.value.config.harmony.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf13 !== void 0 ? _detailObj$value$conf13 : detailObj.value.config.harmony[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'huawei_foreign':
              detailForm.value.publishType = detailObj.value.productType;
              detailForm.value.rateList = ((_detailObj$value37 = detailObj.value) === null || _detailObj$value37 === void 0 || (_detailObj$value37 = _detailObj$value37.radioConfig) === null || _detailObj$value37 === void 0 || (_detailObj$value37 = _detailObj$value37.huawei_foreign) === null || _detailObj$value37 === void 0 || (_detailObj$value37 = _detailObj$value37.divide) === null || _detailObj$value37 === void 0 ? void 0 : _detailObj$value37.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '50%',
                value: '0.5',
                isDefault: true
              }, {
                label: '70%',
                value: '0.7',
                isDefault: false
              }];
              detailForm.value.divide = (_detailForm$value$rat5 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat5 === void 0 ? void 0 : _detailForm$value$rat5.value;
              if ((_detailObj$value38 = detailObj.value) !== null && _detailObj$value38 !== void 0 && (_detailObj$value38 = _detailObj$value38.config) !== null && _detailObj$value38 !== void 0 && _detailObj$value38.huawei_foreign) {
                var _detailObj$value$conf14;
                const matchItem = (_detailObj$value$conf14 = detailObj.value.config.huawei_foreign.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf14 !== void 0 ? _detailObj$value$conf14 : detailObj.value.config.huawei_foreign[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'huawei_mg':
              detailForm.value.publishType = detailObj.value.productType;
              detailForm.value.rateList = ((_detailObj$value39 = detailObj.value) === null || _detailObj$value39 === void 0 || (_detailObj$value39 = _detailObj$value39.radioConfig) === null || _detailObj$value39 === void 0 || (_detailObj$value39 = _detailObj$value39.huawei_mg) === null || _detailObj$value39 === void 0 || (_detailObj$value39 = _detailObj$value39.divide) === null || _detailObj$value39 === void 0 ? void 0 : _detailObj$value39.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '50%',
                value: '0.5',
                isDefault: true
              }, {
                label: '70%',
                value: '0.7',
                isDefault: false
              }];
              detailForm.value.divide = (_detailForm$value$rat6 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat6 === void 0 ? void 0 : _detailForm$value$rat6.value;
              if ((_detailObj$value40 = detailObj.value) !== null && _detailObj$value40 !== void 0 && (_detailObj$value40 = _detailObj$value40.config) !== null && _detailObj$value40 !== void 0 && _detailObj$value40.huawei_mg) {
                var _detailObj$value$conf15;
                const matchItem = (_detailObj$value$conf15 = detailObj.value.config.huawei_mg.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf15 !== void 0 ? _detailObj$value$conf15 : detailObj.value.config.huawei_mg[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'huawei_runtime_fastgame':
              detailForm.value.publishType = detailObj.value.productType;
              detailForm.value.rateList = ((_detailObj$value41 = detailObj.value) === null || _detailObj$value41 === void 0 || (_detailObj$value41 = _detailObj$value41.radioConfig) === null || _detailObj$value41 === void 0 || (_detailObj$value41 = _detailObj$value41.huawei_runtime_fastgame) === null || _detailObj$value41 === void 0 || (_detailObj$value41 = _detailObj$value41.divide) === null || _detailObj$value41 === void 0 ? void 0 : _detailObj$value41.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '50%',
                value: '0.5',
                isDefault: true
              }, {
                label: '70%',
                value: '0.7',
                isDefault: false
              }];
              detailForm.value.divide = (_detailForm$value$rat7 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat7 === void 0 ? void 0 : _detailForm$value$rat7.value;
              if ((_detailObj$value42 = detailObj.value) !== null && _detailObj$value42 !== void 0 && (_detailObj$value42 = _detailObj$value42.config) !== null && _detailObj$value42 !== void 0 && _detailObj$value42.huawei_runtime_fastgame) {
                var _detailObj$value$conf16;
                const matchItem = (_detailObj$value$conf16 = detailObj.value.config.huawei_runtime_fastgame.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf16 !== void 0 ? _detailObj$value$conf16 : detailObj.value.config.huawei_runtime_fastgame[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'amazon':
              detailForm.value.pkg = (_data$amazon = data.amazon) === null || _data$amazon === void 0 ? void 0 : _data$amazon.pkg;
              detailForm.value.rateList = ((_detailObj$value43 = detailObj.value) === null || _detailObj$value43 === void 0 || (_detailObj$value43 = _detailObj$value43.radioConfig) === null || _detailObj$value43 === void 0 || (_detailObj$value43 = _detailObj$value43.amazon) === null || _detailObj$value43 === void 0 || (_detailObj$value43 = _detailObj$value43.divide) === null || _detailObj$value43 === void 0 ? void 0 : _detailObj$value43.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '80%',
                value: '0.8',
                isDefault: true
              }];
              detailForm.value.divide = (_detailForm$value$rat8 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat8 === void 0 ? void 0 : _detailForm$value$rat8.value;
              if ((_detailObj$value44 = detailObj.value) !== null && _detailObj$value44 !== void 0 && (_detailObj$value44 = _detailObj$value44.config) !== null && _detailObj$value44 !== void 0 && _detailObj$value44.amazon) {
                var _detailObj$value$conf17;
                const matchItem = (_detailObj$value$conf17 = detailObj.value.config.amazon.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf17 !== void 0 ? _detailObj$value$conf17 : detailObj.value.config.amazon[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
                detailForm.value.pkg = matchItem === null || matchItem === void 0 ? void 0 : matchItem.pkg;
              }
              break;
            case 'vivo':
              detailForm.value.cpId = (_data$vivo = data.vivo) === null || _data$vivo === void 0 ? void 0 : _data$vivo.cpId;
              detailForm.value.rateList = ((_detailObj$value45 = detailObj.value) === null || _detailObj$value45 === void 0 || (_detailObj$value45 = _detailObj$value45.radioConfig) === null || _detailObj$value45 === void 0 || (_detailObj$value45 = _detailObj$value45.vivo) === null || _detailObj$value45 === void 0 || (_detailObj$value45 = _detailObj$value45.divide) === null || _detailObj$value45 === void 0 ? void 0 : _detailObj$value45.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '85%',
                value: '0.85',
                isDefault: true
              }];
              detailForm.value.divide = (_detailForm$value$rat9 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat9 === void 0 ? void 0 : _detailForm$value$rat9.value;
              if ((_detailObj$value46 = detailObj.value) !== null && _detailObj$value46 !== void 0 && (_detailObj$value46 = _detailObj$value46.config) !== null && _detailObj$value46 !== void 0 && _detailObj$value46.vivo) {
                var _detailObj$value$conf18;
                const matchItem = (_detailObj$value$conf18 = detailObj.value.config.vivo.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf18 !== void 0 ? _detailObj$value$conf18 : detailObj.value.config.vivo[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'oppo':
              detailForm.value.rateList = ((_detailObj$value47 = detailObj.value) === null || _detailObj$value47 === void 0 || (_detailObj$value47 = _detailObj$value47.radioConfig) === null || _detailObj$value47 === void 0 || (_detailObj$value47 = _detailObj$value47.oppo) === null || _detailObj$value47 === void 0 || (_detailObj$value47 = _detailObj$value47.divide) === null || _detailObj$value47 === void 0 ? void 0 : _detailObj$value47.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '85%',
                value: '0.85',
                isDefault: true
              }];
              detailForm.value.divide = (_detailForm$value$rat10 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat10 === void 0 ? void 0 : _detailForm$value$rat10.value;
              if ((_detailObj$value48 = detailObj.value) !== null && _detailObj$value48 !== void 0 && (_detailObj$value48 = _detailObj$value48.config) !== null && _detailObj$value48 !== void 0 && _detailObj$value48.oppo) {
                var _detailObj$value$conf19;
                const matchItem = (_detailObj$value$conf19 = detailObj.value.config.oppo.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf19 !== void 0 ? _detailObj$value$conf19 : detailObj.value.config.oppo[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'xiaomi':
              detailForm.value.rateList = ((_detailObj$value49 = detailObj.value) === null || _detailObj$value49 === void 0 || (_detailObj$value49 = _detailObj$value49.radioConfig) === null || _detailObj$value49 === void 0 || (_detailObj$value49 = _detailObj$value49.xiaomi) === null || _detailObj$value49 === void 0 || (_detailObj$value49 = _detailObj$value49.divide) === null || _detailObj$value49 === void 0 ? void 0 : _detailObj$value49.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '85%',
                value: '0.85',
                isDefault: true
              }];
              detailForm.value.divide = (_detailForm$value$rat11 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat11 === void 0 ? void 0 : _detailForm$value$rat11.value;
              if ((_detailObj$value50 = detailObj.value) !== null && _detailObj$value50 !== void 0 && (_detailObj$value50 = _detailObj$value50.config) !== null && _detailObj$value50 !== void 0 && _detailObj$value50.xiaomi) {
                var _detailObj$value$conf20;
                const matchItem = (_detailObj$value$conf20 = detailObj.value.config.xiaomi.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf20 !== void 0 ? _detailObj$value$conf20 : detailObj.value.config.xiaomi[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'ksminigame':
              detailForm.value.cpId = (_data$vivo2 = data.vivo) === null || _data$vivo2 === void 0 ? void 0 : _data$vivo2.cpId;
              detailForm.value.rateList = ((_detailObj$value51 = detailObj.value) === null || _detailObj$value51 === void 0 || (_detailObj$value51 = _detailObj$value51.radioConfig) === null || _detailObj$value51 === void 0 || (_detailObj$value51 = _detailObj$value51.ksminigame) === null || _detailObj$value51 === void 0 || (_detailObj$value51 = _detailObj$value51.divide) === null || _detailObj$value51 === void 0 ? void 0 : _detailObj$value51.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '80%',
                value: '0.8',
                isDefault: true
              }, {
                label: '50%',
                value: '0.5',
                isDefault: false
              }];
              detailForm.value.divide = (_detailForm$value$rat12 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat12 === void 0 ? void 0 : _detailForm$value$rat12.value;
              if ((_detailObj$value52 = detailObj.value) !== null && _detailObj$value52 !== void 0 && (_detailObj$value52 = _detailObj$value52.config) !== null && _detailObj$value52 !== void 0 && _detailObj$value52.ksminigame) {
                var _detailObj$value$conf21;
                const matchItem = (_detailObj$value$conf21 = detailObj.value.config.ksminigame.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf21 !== void 0 ? _detailObj$value$conf21 : detailObj.value.config.ksminigame[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'ksiosminigame':
              detailForm.value.rateList = ((_detailObj$value53 = detailObj.value) === null || _detailObj$value53 === void 0 || (_detailObj$value53 = _detailObj$value53.radioConfig) === null || _detailObj$value53 === void 0 || (_detailObj$value53 = _detailObj$value53.ksiosminigame) === null || _detailObj$value53 === void 0 || (_detailObj$value53 = _detailObj$value53.divide) === null || _detailObj$value53 === void 0 ? void 0 : _detailObj$value53.map(item => {
                return {
                  label: Number(item.dictName * 100).toFixed(2) + '%',
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '80%',
                value: '0.8',
                isDefault: true
              }, {
                label: '50%',
                value: '0.5',
                isDefault: false
              }];
              detailForm.value.divide = (_detailForm$value$rat13 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat13 === void 0 ? void 0 : _detailForm$value$rat13.value;
              if ((_detailObj$value54 = detailObj.value) !== null && _detailObj$value54 !== void 0 && (_detailObj$value54 = _detailObj$value54.config) !== null && _detailObj$value54 !== void 0 && _detailObj$value54.ksiosminigame) {
                var _detailObj$value$conf22;
                const matchItem = (_detailObj$value$conf22 = detailObj.value.config.ksiosminigame.find(item => item.pkg === curPkg.value)) !== null && _detailObj$value$conf22 !== void 0 ? _detailObj$value$conf22 : detailObj.value.config.ksiosminigame[0];
                Object.assign(detailForm.value, matchItem);
                Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
              }
              break;
            case 'tiktok':
              detailForm.value.rateList = ((_detailObj$value55 = detailObj.value) === null || _detailObj$value55 === void 0 || (_detailObj$value55 = _detailObj$value55.radioConfig) === null || _detailObj$value55 === void 0 || (_detailObj$value55 = _detailObj$value55.tiktok) === null || _detailObj$value55 === void 0 || (_detailObj$value55 = _detailObj$value55.divide) === null || _detailObj$value55 === void 0 ? void 0 : _detailObj$value55.map(item => {
                return {
                  label: item.dictName,
                  value: item.dictValue.toString(),
                  isDefault: item.defaultOption == 1
                };
              })) || [{
                label: '80%',
                value: '0.8',
                isDefault: true
              }, {
                label: '50%',
                value: '0.5',
                isDefault: false
              }];
              detailForm.value.divide = (_detailForm$value$rat14 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat14 === void 0 ? void 0 : _detailForm$value$rat14.value;
              if ((_detailObj$value56 = detailObj.value) !== null && _detailObj$value56 !== void 0 && (_detailObj$value56 = _detailObj$value56.config) !== null && _detailObj$value56 !== void 0 && _detailObj$value56.tiktok) {
                var _detailObj$value57, _detailObj$value58;
                Object.assign(detailForm.value, (_detailObj$value57 = detailObj.value) === null || _detailObj$value57 === void 0 || (_detailObj$value57 = _detailObj$value57.config) === null || _detailObj$value57 === void 0 || (_detailObj$value57 = _detailObj$value57.tiktok) === null || _detailObj$value57 === void 0 ? void 0 : _detailObj$value57[0]);
                Object.assign(detailForm.value, (_detailObj$value58 = detailObj.value) === null || _detailObj$value58 === void 0 || (_detailObj$value58 = _detailObj$value58.config) === null || _detailObj$value58 === void 0 || (_detailObj$value58 = _detailObj$value58.tiktok) === null || _detailObj$value58 === void 0 || (_detailObj$value58 = _detailObj$value58[0]) === null || _detailObj$value58 === void 0 ? void 0 : _detailObj$value58.channelData);
              }
              break;
            case 'bilibili_minigame_pay':
              {
                var _detailObj$value$radi, _detailObj$value59, _detailObj$value60, _radioCfg$divide, _detailForm$value$rat15, _detailForm$value$rat16, _detailObj$value$conf23, _detailObj$value61, _detailObj$value62;
                const radioCfg = (_detailObj$value$radi = (_detailObj$value59 = detailObj.value) === null || _detailObj$value59 === void 0 || (_detailObj$value59 = _detailObj$value59.radioConfig) === null || _detailObj$value59 === void 0 ? void 0 : _detailObj$value59.bilibili_minigame_pay) !== null && _detailObj$value$radi !== void 0 ? _detailObj$value$radi : (_detailObj$value60 = detailObj.value) === null || _detailObj$value60 === void 0 || (_detailObj$value60 = _detailObj$value60.radioConfig) === null || _detailObj$value60 === void 0 ? void 0 : _detailObj$value60.bilibiliMinigamePay;
                detailForm.value.mchName = data.mchName;
                detailForm.value.rateList = (radioCfg === null || radioCfg === void 0 || (_radioCfg$divide = radioCfg.divide) === null || _radioCfg$divide === void 0 ? void 0 : _radioCfg$divide.map(item => {
                  return {
                    label: item.dictName,
                    value: item.dictValue.toString(),
                    isDefault: item.defaultOption == 1
                  };
                })) || [{
                  label: '60%',
                  value: '0.6',
                  isDefault: true
                }, {
                  label: '80%',
                  value: '0.8',
                  isDefault: false
                }];
                detailForm.value.shareRatio = (_detailForm$value$rat15 = (_detailForm$value$rat16 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat16 === void 0 ? void 0 : _detailForm$value$rat16.value) !== null && _detailForm$value$rat15 !== void 0 ? _detailForm$value$rat15 : '';
                const blCfg = (_detailObj$value$conf23 = (_detailObj$value61 = detailObj.value) === null || _detailObj$value61 === void 0 || (_detailObj$value61 = _detailObj$value61.config) === null || _detailObj$value61 === void 0 ? void 0 : _detailObj$value61.bilibili_minigame_pay) !== null && _detailObj$value$conf23 !== void 0 ? _detailObj$value$conf23 : (_detailObj$value62 = detailObj.value) === null || _detailObj$value62 === void 0 || (_detailObj$value62 = _detailObj$value62.config) === null || _detailObj$value62 === void 0 ? void 0 : _detailObj$value62.bilibiliMinigamePay;
                if (blCfg) {
                  var _list$find;
                  const list = Array.isArray(blCfg) ? blCfg : [blCfg];
                  const matchItem = (_list$find = list.find(item => item.pkg === curPkg.value)) !== null && _list$find !== void 0 ? _list$find : list[0];
                  Object.assign(detailForm.value, matchItem);
                  Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
                }
                break;
              }
            case 'meta_vr_pay':
              {
                var _detailObj$value$radi2, _detailObj$value63, _detailObj$value64, _radioCfg$divide2, _detailForm$value$rat17, _detailForm$value$rat18, _detailObj$value$conf24, _detailObj$value65, _detailObj$value66;
                const radioCfg = (_detailObj$value$radi2 = (_detailObj$value63 = detailObj.value) === null || _detailObj$value63 === void 0 || (_detailObj$value63 = _detailObj$value63.radioConfig) === null || _detailObj$value63 === void 0 ? void 0 : _detailObj$value63.meta_vr_pay) !== null && _detailObj$value$radi2 !== void 0 ? _detailObj$value$radi2 : (_detailObj$value64 = detailObj.value) === null || _detailObj$value64 === void 0 || (_detailObj$value64 = _detailObj$value64.radioConfig) === null || _detailObj$value64 === void 0 ? void 0 : _detailObj$value64.metaVrPay;
                detailForm.value.mchName = data.mchName;
                detailForm.value.rateList = (radioCfg === null || radioCfg === void 0 || (_radioCfg$divide2 = radioCfg.divide) === null || _radioCfg$divide2 === void 0 ? void 0 : _radioCfg$divide2.map(item => {
                  return {
                    label: item.dictName,
                    value: item.dictValue.toString(),
                    isDefault: item.defaultOption == 1
                  };
                })) || [{
                  label: '60%',
                  value: '0.6',
                  isDefault: true
                }, {
                  label: '80%',
                  value: '0.8',
                  isDefault: false
                }];
                detailForm.value.divide = (_detailForm$value$rat17 = (_detailForm$value$rat18 = detailForm.value.rateList.find(item => item.isDefault)) === null || _detailForm$value$rat18 === void 0 ? void 0 : _detailForm$value$rat18.value) !== null && _detailForm$value$rat17 !== void 0 ? _detailForm$value$rat17 : '';
                const metaCfg = (_detailObj$value$conf24 = (_detailObj$value65 = detailObj.value) === null || _detailObj$value65 === void 0 || (_detailObj$value65 = _detailObj$value65.config) === null || _detailObj$value65 === void 0 ? void 0 : _detailObj$value65.meta_vr_pay) !== null && _detailObj$value$conf24 !== void 0 ? _detailObj$value$conf24 : (_detailObj$value66 = detailObj.value) === null || _detailObj$value66 === void 0 || (_detailObj$value66 = _detailObj$value66.config) === null || _detailObj$value66 === void 0 ? void 0 : _detailObj$value66.metaVrPay;
                if (metaCfg) {
                  var _list$find2;
                  const list = Array.isArray(metaCfg) ? metaCfg : [metaCfg];
                  const matchItem = (_list$find2 = list.find(item => item.pkg === curPkg.value)) !== null && _list$find2 !== void 0 ? _list$find2 : list[0];
                  Object.assign(detailForm.value, matchItem);
                  Object.assign(detailForm.value, matchItem === null || matchItem === void 0 ? void 0 : matchItem.channelData);
                }
                break;
              }
            case 'recordUpdate':
              break;
          }
        }
      } catch (e) {}
    };
    watch(() => props.modalVisible, newVal => {
      if (newVal) {
        curChannel.value = props.choosedChannel;
        getChannelConfig('init');
      }
    }); // 监听modalVisible变化
    return (_ctx, _cache) => {
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_popconfirm = _resolveComponent("a-popconfirm");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_empty = _resolveComponent("a-empty");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_drawer = _resolveComponent("a-drawer");
      return _openBlock(), _createBlock(_component_a_drawer, {
        open: __props.modalVisible,
        class: "custom-class",
        placement: "right",
        title: "支付渠道",
        closable: false,
        width: "956px",
        bodyStyle: {
          paddingTop: '0px',
          paddingBottom: '0px',
          paddingLeft: '0px',
          paddingRight: '0px',
          overflow: 'hidden'
        },
        onClose: handleCancel
      }, {
        default: _withCtx(() => [_createVNode(_component_a_spin, {
          spinning: loading.value
        }, {
          default: _withCtx(() => {
            var _payChannelList$value3;
            return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
              src: _unref(curLogoImg),
              class: "logo_img"
            }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(__props.productItem.appName), 1), _createElementVNode("div", null, [_createVNode(_component_a_tag, {
              color: "green",
              bordered: false
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(getPubStatusProperty)(__props.productItem.pubStatus, 'label') || '--'), 1)]),
              _: 1
            }), _createVNode(_component_a_tag, {
              color: "blue",
              bordered: false
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.productItem.publishPlatformName), 1)]),
              _: 1
            })])])]), _createElementVNode("div", _hoisted_6, [!['google', 'apple'].includes(curChannel.value) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelList.value, item => {
              return _openBlock(), _createElementBlock("div", {
                key: item.chnlFlag,
                class: _normalizeClass(["channel_item", {
                  active: curChannel.value === item.chnlFlag
                }]),
                onClick: $event => changeChannel(item)
              }, [_createElementVNode("span", {
                class: "name",
                title: item.channelName
              }, _toDisplayString(item.channelName), 9, _hoisted_9), _createElementVNode("span", {
                class: "code",
                title: item.chnlFlag
              }, _toDisplayString(`（${item.chnlFlag}）`), 9, _hoisted_10)], 10, _hoisted_8);
            }), 128)), _createVNode(_component_a_popconfirm, {
              title: "确定从产品中台同步更新所有支付渠道吗？",
              "ok-text": "确定",
              "cancel-text": "取消",
              onConfirm: _cache[0] || (_cache[0] = $event => syncDetail())
            }, {
              default: _withCtx(() => {
                var _channelList$value;
                return [_createVNode(_component_a_button, {
                  type: "link",
                  class: _normalizeClass(["sync_btn", {
                    border: (_channelList$value = channelList.value) === null || _channelList$value === void 0 ? void 0 : _channelList$value.length
                  }])
                }, {
                  default: _withCtx(() => [_createTextVNode("同步支付渠道")]),
                  _: 1
                }, 8, ["class"])];
              }),
              _: 1
            })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [(_payChannelList$value3 = payChannelList.value) !== null && _payChannelList$value3 !== void 0 && _payChannelList$value3.length ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_a_tabs, {
              activeKey: curPayChannel.value,
              "onUpdate:activeKey": _cache[1] || (_cache[1] = $event => curPayChannel.value = $event),
              onChange: changePayChannel
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payChannelList.value, item => {
                return _openBlock(), _createBlock(_component_a_tab_pane, {
                  tab: item.payChlName,
                  key: item.payChnlConfigComponent
                }, null, 8, ["tab"]);
              }), 128))]),
              _: 1
            }, 8, ["activeKey"])]), _createElementVNode("div", _hoisted_13, [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentsObj)[curPayChannel.value]), {
              "detail-form": detailForm.value,
              rules: _unref(rules),
              ref: _unref(refObj)[curPayChannel.value],
              prodChnl: curPayChannel.value,
              onSetVisible: setVisible,
              onSubmitForm: _unref(submitForm)
            }, null, 40, ["detail-form", "rules", "prodChnl", "onSubmitForm"])), _createElementVNode("div", _hoisted_14, [!['google', 'apple', 'amazon', 'vivo', 'oppo', 'xiaomi', 'recordUpdate'].includes(curPayChannel.value) ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              onClick: toHelpWord
            }, {
              default: _withCtx(() => [_createTextVNode(" 查看操作指引 ")]),
              _: 1
            })) : _createCommentVNode("", true), !['google', 'apple', 'recordUpdate'].includes(curPayChannel.value) ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              class: _normalizeClass(['save-btn', {
                m12: !['google', 'apple', 'amazon', 'vivo', 'oppo', 'xiaomi', 'recordUpdate'].includes(curPayChannel.value)
              }]),
              type: "primary",
              onClick: _unref(savePaySetting)
            }, {
              default: _withCtx(() => [_createTextVNode(" 保存 ")]),
              _: 1
            }, 8, ["class", "onClick"])) : _createCommentVNode("", true)])])], 64)) : (_openBlock(), _createBlock(_component_a_empty, {
              key: 1,
              class: "no_pay_channel",
              image: _unref(simpleImage),
              description: "暂无对应支付渠道"
            }, null, 8, ["image"]))])])];
          }),
          _: 1
        }, 8, ["spinning"]), _createVNode(_component_a_image, {
          width: 200,
          style: {
            display: 'none'
          },
          preview: {
            visible: imageVisible.value,
            onVisibleChange: setVisible
          },
          src: _unref(imgUrl)[curPayChannel.value]
        }, null, 8, ["preview", "src"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});